export const MUI_X_LICENSE = "3e06ca7ad35cc585598cdcbf45091b09Tz05MzU1MyxFPTE3NTE1MzczNDgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=";
